// LEN-213 (designer D3): the rule editor, rule libraries and the test on stored runs
// (Lender.Optimus.Ai AiRulesDesignerController). The test replays stored runs read-only and calls
// no model; nothing here writes.
export class AiRulesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDesigner({ signal } = {}) {
    return this.#http.get('/api/ai-config/rules/designer', { signal });
  }

  async getDataModel({ rule, libraryId = null, libraryVersion = null, signal }) {
    return this.#http.post(
      '/api/ai-config/rules/data-model',
      { rule, libraryId, libraryVersion },
      { signal },
    );
  }

  // The data model of a trigger with no draft rule (a step phase's `when` reads trigger phaseStart,
  // which the server compiles without the register root, so it asks for the model without it).
  async getTriggerDataModel({ trigger, hasRegister = true, signal }) {
    return this.#http.get('/api/ai-config/rules/data-model', {
      params: { trigger, hasRegister },
      signal,
    });
  }

  async checkRule({ rule, libraryId = null, libraryVersion = null, importParams = null, signal }) {
    return this.#http.post(
      '/api/ai-config/rules/check',
      { rule, libraryId, libraryVersion, importParams },
      { signal },
    );
  }

  async getLibraries({ signal } = {}) {
    return this.#http.get('/api/ai-config/rule-libraries', { signal });
  }

  async getLibrary({ libraryId, version, signal }) {
    return this.#http.get(
      `/api/ai-config/rule-libraries/${encodeURIComponent(libraryId)}/versions/${version}`,
      { signal },
    );
  }

  // The library version's summary: its params and each rule's id, title, description, trigger,
  // action, mode and replaces (no expressions, no fixture results): the detail page's first load.
  async getLibrarySummary({ libraryId, version, signal }) {
    return this.#http.get(
      `/api/ai-config/rule-libraries/${encodeURIComponent(libraryId)}/versions/${version}/summary`,
      { signal },
    );
  }

  // Every rule's check (compiles, fixture results, errors), computed once per version.
  async getLibraryChecks({ libraryId, version, signal }) {
    return this.#http.get(
      `/api/ai-config/rule-libraries/${encodeURIComponent(libraryId)}/versions/${version}/checks`,
      { signal },
    );
  }

  // One rule in full (what the editor opens) with its check.
  async getLibraryRule({ libraryId, version, ruleId, signal }) {
    return this.#http.get(
      `/api/ai-config/rule-libraries/${encodeURIComponent(libraryId)}/versions/${version}/rules/${encodeURIComponent(ruleId)}`,
      { signal },
    );
  }

  async testRules({ processId, body, signal }) {
    return this.#http.post(`/api/ai-config/processes/${processId}/rules/test`, body, { signal });
  }
}
